<template>
  <a-modal
    :visible="visible"
    :permission="permission"
    :description="description"
    :title="title"
    okText="Save"
    @cancel="() => { $emit('cancel') }"
    @ok="() => { $emit('create') }"
  >
    <a-form layout="vertical" :form="form">
      <a-form-item label="Permission">
        <a-input
          :size="size"
          :disabled="isUpdate"
          v-decorator="[
              'permission',
              {
                rules: [{ required: true, message: 'Please input a valid permission!', pattern: new RegExp(/^[A-Za-z0-9]+(?::[A-Za-z0-9]+)+$/) }], initialValue: permission
              }
            ]"
        />
      <a-alert  type="info" showIcon style="margin-top:5px;">
        <div slot="message">One or more alphanumeric strings separated by colon. Example: <a-tag color="pink">delete</a-tag><a-tag color="red">comment:read</a-tag><a-tag color="orange">blog:post:write</a-tag></div>
      </a-alert>
      </a-form-item>
      <a-form-item label="Description">
        <a-input
          :size="size"
          v-decorator="[
              'description',
              {
                rules: [{ required: true, message: 'Please input a description!' }], initialValue: description
              }
            ]"
        />
      <a-alert  type="info" showIcon style="margin-top:5px;">
        <div slot="message">User friendly description which can be displayed on consent screen.</div>
      </a-alert>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>

export default {
  data() {
    return {
      size: 'large'
    }
  },
  props: ["visible", "permission", "description", "title", "resource", 'isUpdate'],
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style>
</style>
